import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import React from 'react';
import { connect } from 'react-redux';
import withAuth from '../../hocs/withAuth';
import { sendPushMessage } from '../../store/actions/auth';
import ButtonContent from '../ButtonContent';
import NavigationTabs from '../nav/NavigationTabs';
import { AlertJsMessage } from './../../helpers.js'

class AddPush extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			title: '',
			message: ''
		};
	}


	handleChange = field => event => {
		this.setState({
			...this.state,
			[field]: event.target.value,
		});
	};

	clearFields = () => {
		this.setState({
			title: '',
			message: ''
		});
	};

	sendMessage() {
		this.props.removeError();
		const { title, message } = this.state;
		const formData = {
			title,
			message
		};
		const required = ['title', 'message'];
		for (var i = 0; i < required.length; i++) {
			if (!formData[required[i]]) {
				AlertJsMessage(`${required[i]} is required.`);
				return;
			}
		}
		const { sendMessage } = this.props;
		sendMessage({ ...formData }).then(response => {
			this.clearFields();
		});
	}

	render() {
		return (
			<div>
				<NavigationTabs
					title="Manage Push Notifications"
					set="managePushNotifications"
					subtitle=""
					activeRoute="/managePushNotifications/add"
				/>
				<div>
					<div>
						<div>
								<div style={{ width: '100%' }}>
									<TextField
										style={{ maxWidth: 400, marginTop: 10, marginRight: 10 }}
										label="Title"
										value={this.state.title}
										onChange={this.handleChange('title')}
										margin="dense"
										variant="outlined"
									/>
								</div>
								<div style={{ width: '100%' }}>
									<TextField
										label="Message"
                                        value={this.state.message}
                                        multiline
                                        rows={4}
                                        id="outlined-multiline-static"
										onChange={this.handleChange('message')}
										variant="outlined"
									/>
                                </div>
							<div style={{ width: '45%', marginTop: '10px' }}>
								<Button
									onClick={() => {
										this.sendMessage();
									}}
									variant="contained"
									color="primary"
								>
									<ButtonContent text="Send" icon="chevron-right" />
								</Button>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state, ownProps) {
	return {
		errors: state.errors,
	};
}
const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		sendMessage: data => {
			return dispatch(sendPushMessage(data));
		}
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(withAuth(AddPush));



// WEBPACK FOOTER //
// ./src/components/managePushNotifications/Add.js